import React, { useEffect } from "react";
import "./App.scss";
import Routing from "./Routes";
import { firebaseCloudMessaging } from "./utils/firebase";
import { toast } from "react-toastify";
import { errorToast } from "./helpers";
import { useAppDispatch } from "./hooks/store";
import { incrementUnreadNotificationCount } from "./reducers/generalSlice";

const App = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    async function setToken() {
      try {
        const fcmToken = await firebaseCloudMessaging.init();
        if (fcmToken) {
          // Optionally, handle the token somewhere else instead of logging
        }
      } catch {
        // Handle error silently or show UI feedback instead of console.error
        // e.g. setError(error);
      }
    }

    setToken();

    // Event listener for push notification in the background
    if ("serviceWorker" in navigator) {
      const messageHandler = (event) => {
        try {
          event?.source?.postMessage("Hi client");
          dispatch(incrementUnreadNotificationCount());
          toast(
            <div style={{ height: "100%" }}>
              <div>{event?.data?.notification?.title}</div>
              <div>{event?.data?.notification?.body}</div>
            </div>
          );

          return event;
        } catch (e) {
          // Optionally handle error silently or via UI feedback, no console.error
          // setError(e);
          return e;
        }
      };

      navigator.serviceWorker.addEventListener("message", messageHandler);

      return () => {
        if ("serviceWorker" in navigator) {
          navigator.serviceWorker.removeEventListener(
            "message",
            messageHandler
          );
        }
      };
    }
  }, []);
  const handleOffline = () => errorToast("No internet");
  useEffect(() => {
    if (typeof window !== "undefined" && window.addEventListener) {
      window.addEventListener("offline", handleOffline, false);
      return () => {
        window.removeEventListener("offline", handleOffline, false);
      };
    }
  }, []);

  return <Routing />;
};

export default App;
